import { type IncidentCrawlerCategory, NOT_CRAWLER_SCOPED } from '@prerender/diagnostics-api';

import { crawlerCategoryLabel } from './crawlerCategoryLabels';
import { incidentTypeLabel } from './incidentTypeLabels';
import TwoLineCell from './TwoLineCell';

type IncidentTypeCellProps = {
  incidentType: string;
  crawlerCategory: IncidentCrawlerCategory;
};

function IncidentTypeCell({ incidentType, crawlerCategory }: IncidentTypeCellProps) {
  if (crawlerCategory === NOT_CRAWLER_SCOPED) {
    return <>{incidentTypeLabel(incidentType)}</>;
  }
  return <TwoLineCell primary={incidentTypeLabel(incidentType)} secondary={crawlerCategoryLabel(crawlerCategory)} />;
}

export default IncidentTypeCell;
